import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OauthService } from '../services/oauth.service';

export const authGuard: CanActivateFn = () => {
  const oauth = inject(OauthService);
  const router = inject(Router);

  return oauth.hasSession() || router.createUrlTree(['/login']);
};
